import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './PatientEdit.css';

const PatientEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [patient, setPatient] = useState({
    hospital_patient_id: '',
    file_path: '',
    date_of_birth: '',
    gender: '',
    data_source: '',
    ethnicity: '',
    diagnosis: '',
    notes: '',
    original_upload_path: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/patients/${id}/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        setPatient(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError('Error fetching patient details');
        setLoading(false);
      });
  }, [id, token]);

  const handleChange = (e) => {
    setPatient({ ...patient, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`${process.env.REACT_APP_BACKEND_URL}/patients/${id}/edit/`, patient, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        setSuccess(true);
        setError('');
      })
      .catch((err) => {
        console.error(err);
        setError('Error updating Patient');
        setSuccess(false);
      });
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this patient?')) {
      axios
        .delete(`${process.env.REACT_APP_BACKEND_URL}/patients/${id}/delete/`, {
          headers: { Authorization: `Token ${token}` },
        })
        .then(() => {
          navigate('/patients');
        })
        .catch((err) => {
          alert('Error deleting patient');
        });
    }
  };

  if (loading) return <div>Loading patient details...</div>;
  if (error && !success) return <p className="error-message">{error}</p>;

  return (
    <div className="patient-edit-container">
      <h2>Edit Patient</h2>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">Patient updated successfully!</p>}
      <form onSubmit={handleSubmit} className="patient-edit-form">
        
        {/* Hospital Patient ID (Required) - disabled in your design */}
        <div className="form-group">
          <label>
            Hospital Patient ID <span className="required-asterisk">*</span>
          </label>
          <input
            type="text"
            name="hospital_patient_id"
            value={patient.hospital_patient_id}
            onChange={handleChange}
            disabled
          />
        </div>
        
        {/* File Path (Required) */}
        <div className="form-group">
          <label>
            File Path <span className="required-asterisk">*</span>
          </label>
          <input
            type="text"
            name="file_path"
            value={patient.file_path || ''}
            onChange={handleChange}
            required
          />
        </div>
        
        {/* Date of Birth (Optional) */}
        <div className="form-group">
          <label>Date of Birth (Optional)</label>
          <input
            type="date"
            name="date_of_birth"
            value={patient.date_of_birth || ''}
            onChange={handleChange}
          />
        </div>
        
        {/* Gender (Optional) */}
        <div className="form-group">
          <label>Gender (Optional)</label>
          <select
            name="gender"
            value={patient.gender || ''}
            onChange={handleChange}
          >
            <option value="">Select Gender</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
          </select>
        </div>
        
        {/* Data Source (Required) */}
        <div className="form-group">
          <label>
            Data Source <span className="required-asterisk">*</span>
          </label>
          <input
            type="text"
            name="data_source"
            value={patient.data_source || ''}
            onChange={handleChange}
            required
          />
        </div>
        
        {/* Ethnicity (Optional) */}
        <div className="form-group">
          <label>Ethnicity (Optional)</label>
          <input
            type="text"
            name="ethnicity"
            value={patient.ethnicity || ''}
            onChange={handleChange}
          />
        </div>
        
        {/* Diagnosis (Optional) */}
        <div className="form-group">
          <label>Diagnosis (Optional)</label>
          <textarea
            name="diagnosis"
            value={patient.diagnosis || ''}
            onChange={handleChange}
          />
        </div>
        
        {/* Notes (Optional) */}
        <div className="form-group">
          <label>Notes (Optional)</label>
          <textarea
            name="notes"
            value={patient.notes || ''}
            onChange={handleChange}
          />
        </div>
        
        {/* Original Upload Path (Required) */}
        <div className="form-group">
          <label>
            Original Upload Path <span className="required-asterisk">*</span>
          </label>
          <input
            type="text"
            name="original_upload_path"
            value={patient.original_upload_path || ''}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-actions">
          <button type="submit">Save Changes</button>
          <button type="button" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </form>
    </div>
  );
};

export default PatientEdit;
